import type { ButtonColor } from './Button';

/**
 * Maps ButtonColor values to CSS module class names.
 *
 * Shared between Button, LinkButton, and CMS components that need
 * to apply the same color classes (e.g. decorative CTA spans).
 */
export const COLOR_CLASS_MAP: Record<ButtonColor, string> = {
  primary: 'colorPrimary',
  black: 'colorBlack',
  white: 'colorWhite',
  blue: 'colorBlue',
};
